import React from "react";
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import BasicTabs from "./BasicTabs";
import {Link} from "react-router-dom";
import PageItemsAcc from "./PageItemsAcc";





export  default function LoadingAcc() {

    return(
        <>


            <div>
                <div className={'flex567'}>
                        <Skeleton width={'40px'} height={'40px'}  circle={true}/>




                    <div className={'d-loading text-right'}>
                                        <Skeleton width={'150px'} height={'5px'}/>
                                            <Skeleton width={'70px'} height={'5px'}/>


                    </div>




                </div>


            </div>




        </>
    )

}